<template>
  <component :is="currentComponent" />
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import YaychatRechargeMobile from './components/YaychatRechargeMobile.vue'
import YaychatRechargeDesktop from './index.vue'

const BREAKPOINT = 1080
const viewportWidth = ref(typeof window === 'undefined' ? BREAKPOINT + 1 : window.innerWidth)

const currentComponent = computed(() => (
  viewportWidth.value <= BREAKPOINT ? YaychatRechargeMobile : YaychatRechargeDesktop
))

function updateViewportWidth() {
  viewportWidth.value = window.innerWidth
}

onMounted(() => {
  updateViewportWidth()
  window.addEventListener('resize', updateViewportWidth)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateViewportWidth)
})
</script>
